export class Dimension {
  /** @constructor */
  constructor(readonly lower: number, readonly upper: number) {
    //this.lower = lower;
    //this.upper = upper;
  }
}
